import gql from 'graphql-tag';

export const EHRENAMTLICHE_FINDEN_VIDEO_FRAGMENT = gql`
fragment ehrenamtlicheFindenVideo on EhrenamtlicheFindenVideoType {
    videoTitle
    videoText
    videoUrl
    id
  }
`;